<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="group flex flex-col items-center gap-8 transition duration-300 hover:scale-[1.02] lg:flex-row lg:gap-10 lg:px-4 xl:px-0"
  >
    <div class="flex w-full flex-1 flex-col gap-3">
      <span
        class="flex h-6 w-6 items-center justify-center rounded-full bg-[#306294] text-[11px] text-white"
        >{{ number }}</span
      >
      <h4 class="text-xl font-semibold md:text-2xl lg:text-3xl">{{ title }}</h4>
      <p class="text-base text-gray-500 lg:text-lg" v-html="desc"></p>
    </div>

    <!-- Placeholder SVG -->
    <img
      :src="imgSrc"
      class="max-h-[328.5px] w-full max-w-[597px] rounded-4xl bg-[#97C9FB] shadow-xl transition duration-300"
    />
  </div>
</template>

<script setup>
defineProps({
  number: Number,
  title: String,
  desc: String,
  imgSrc: String,
});
</script>
